import Box from "@@/elements/Box";
import Icon, { IconTypes } from "@@/elements/Icons/Icon";
import { Minus } from "@@/elements/Icons/icons";
import Plus from "@@/elements/Icons/icons/Plus";
import Typhography from "@@/elements/Typography";
import cn from "classnames";
import { useState } from "react";
import TextButtonIcon from "../Button/TextButtonIcon";
import styles from "./index.module.scss";

export type ListItemProp = {
  icon?: IconTypes;
  text: string;
};
export type UnorderedListProps = {
  listItems: ListItemProp[];
  textVariant?: "intro" | "body";
  collapse?: boolean;
  showText?: string;
  hideText?: string;
};

const UnorderedList = ({ listItems,
  textVariant = "body",
  collapse,
  showText,
  hideText,
} : UnorderedListProps) => {
  const [collapsed, setCollapsed] = useState(true);
  const shouldCollapse = listItems?.length > 2 && collapse;

  const getListItemClass = (index: number) => {
    return cn({
      [styles.collapsed]: shouldCollapse && collapsed && index > 1,
      [styles.faded]: shouldCollapse && index == 1 && collapsed && listItems.length > 2,
    });
  };

  return (
    <>
      { listItems && listItems.length > 0 && (
        <>
          <ul className={styles.unordered_list}>
            {listItems.map((item, index) => {
              const textColor = item.icon === "closeFilled" ? "PrimaryGrey" : "ComplementaryCharcoal";
              return (
                <li
                  key={index}
                  className={getListItemClass(index)}>
                  <Box
                    width={6}
                    height={6}
                    ml={-10}
                    alignContent="center"
                    justifyContent="center"
                    flexShrink={0}>
                    <Icon
                      aria-hidden="true"
                      className={styles.unordered_list_icon}
                      name={item.icon ?? "checkThin"}/>
                  </Box>
                  <Typhography
                    asElement="span"
                    color={textColor}
                    variant={textVariant}>{item.text}</Typhography>
                </li>
              );
            })}
          </ul>
          {shouldCollapse && (
            <Box
              mt={6}
              alignItems="center">
              <TextButtonIcon
                onClick={() => setCollapsed(!collapsed)}
                textVariant="link"
                direction="right"
                label={collapsed ? showText : hideText}
                dense>
                {collapsed ? <Plus /> : <Minus />}
              </TextButtonIcon>
            </Box>
          )}
        </>
      )
      }
    </>);
};

export default UnorderedList;